import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_BOX, LAYOUT_SIDEBAR } from 'config/constants/ui'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const LayoutContainer = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   const isSidebarGL = theme.tmpGlobalLayout === LAYOUT_SIDEBAR
   let componentProps

   if (isBoxGL) {
      componentProps = {
         marginTop: '5px',
         paddingRight: `
            calc(210px + ${theme.tmpViewportPaddingD})[d]
            calc(250px + ${theme.tmpViewportPaddingE})[e]
            calc(250px + ${theme.tmpViewportPaddingF})[f]
         `
      }
   }

   if (isSidebarGL) {
      componentProps = {
         height: '100vh',
         scroll: 'on'
      }
   }

   return (
      <View
         display="flex"
         justifyContent="center"
         position="relative"
         width="100%"
         {...componentProps}>
         <View
            width="100%"
            minHeight="100vh"
            backgroundColor={theme.tmpContentBackgroundColor}
            scroll={isSidebarGL && 'on'}>
            {children}
         </View>
      </View>
   )
}

LayoutContainer.propTypes = {
   children: PropTypes.node.isRequired
}

export default LayoutContainer
